module.exports = __webpack_public_path__ + "img/mercedes-benz-g-2022-768x507.054a386c.jpg";